import React from 'react';


export class Button extends React.Component {

  constructor(props) {
    super(props);

    this.checkProps = this.checkProps.bind(this);

    this.checkProps(props);
  }

  componentWillReceiveProps(nextProps){
    this.checkProps(nextProps);
  }

  checkProps(props){
    this.className = this.props.className ? this.props.className.split(' ').map( c => c.trim() ) : [];

    this.className.push('btn', 'btn-obelux');

    switch(props.size){
      case 'lg':
        this.className.push('btn-lg');
        break;
      case 'sm':
        this.className.push('btn-sm');
        break;
      default:
    }

    switch(props.type){
      case "button":
      case "submit":
        this.className.push(this.props.type);
        break;
      default:
        this.className.push("button");
    }

    switch(props.shape){
      case "block":
        this.className.push("btn-square");
        break;
      default:
        this.className.push("btn-round");
    }

    switch(props.color){
      case "secondary":
        this.className.push("btn-obelux-secondary");
        break;
      default:
        this.className.push("btn-obelux-primary");
    }
  }

  render(){
    const props = { ...this.props, ...this.props.attributes };

    delete props.attributes;

    props.className = this.className.join(" ");

    return (
      <button { ...props }>
        { this.props.children }
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/button/Button.js